import { render, staticRenderFns } from "./ConfettiThree.vue?vue&type=template&id=1f014b7c&scoped=true&lang=pug&"
import script from "./ConfettiThree.vue?vue&type=script&lang=js&"
export * from "./ConfettiThree.vue?vue&type=script&lang=js&"
import style0 from "./ConfettiThree.vue?vue&type=style&index=0&id=1f014b7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f014b7c",
  null
  
)

export default component.exports